{
  "version": 1,
  "asset_id": "71ac414e-2637-4b9a-8bbe-7e5f0902b940",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/71ac414e-2637-4b9a-8bbe-7e5f0902b940/engine-hero.webp",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/71ac414e-2637-4b9a-8bbe-7e5f0902b940/engine-hero.webp",
  "original_filename": "engine-hero.webp",
  "size": 152058,
  "content_type": "image/webp",
  "created_at": "2026-06-27T00:30:16Z"
}
